import createCache from "@emotion/cache";
import { EmotionCache } from "@emotion/react";

export const createEmotionCache = (): EmotionCache => createCache({ key: "css" });
